// Cache anahtarları için prefix tanımlamaları
export const CACHE_KEYS = {
  CONTENT_LIST: 'content-list',
  CONTENT_DETAIL: 'content-detail',
}

// TTL (Time-to-Live) değerleri
export const TTL_VALUES = {
  CONTENT_LIST: {
    default: '2m',     // Varsayılan liste TTL (2 dakika)
    trending: '30s',   // Trend içerikleri için daha kısa TTL (30 saniye)
    scheduled: '5m',    // Planlanmış içerikler için daha uzun TTL (5 dakika)
  },
  CONTENT_DETAIL: {
    default: '5m',     // Varsayılan detay TTL (5 dakika)
    published: '10m',  // Yayınlanmış içerikler için daha uzun TTL (10 dakika)
    draft: '1m',        // Taslak içerikler için daha kısa TTL (1 dakika)
  },
  LIST_VIEW_CHANGE: '5s', // Görünüm değişiminde 5 saniye
}

// Entity tipleri
export const ENTITY_TYPES = {
  INTERNAL_SOURCE: 1,
  OUT_SOURCE: 2,
  OPTIMIZED: 3,
  AUTO_OPTIMIZING: 4,
  AUTO_OPTIMIZED: 5,
  REVISED: 6,
  TREND_ARTICLE: 7,
  PLANNED_CONTENT: 8,
}

// Entity durumları
export const ENTITY_STATUS = {
  PUBLISHED: 1,
  DRAFT: 2,
}
